import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';
import cl from "./Edit.module.css";
import Plus from "../../../../assets/Icon/Plus"; 
import Modal from '../../../UI/Modal/Modal';
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { Link } from 'react-router-dom'; 
import AddClientForm from '../ClientForm/ClientForm';
import { validatePhoneNumber } from '../../../../utils/phone';
import Sale from '../Sale/Sale';
import Invoice from '../Invoice/Invoice';

const initEditPrice = (Booking) => {
    console.log("Booking in edit", Booking)
    return {
        id: Booking.id,
        booking_id: Booking.booking_id,
        seller_id: Booking.seller_id,
        status_id: Booking.status_id,
        user_id: Booking.user_id,
        sender_country_id: Booking.sender_country_id,
        sender_city_id: Booking.sender_city_id,
        reciever_country_id: Booking.reciever_country_id,
        reciever_city_id: Booking.reciever_city_id,
        reciever_country: Booking.reciever_country,
        sender_country: Booking.sender_country,
        type_id: Booking.type_id,
        created_at: Booking.created_at || '',
        driver_id: Booking.driver_id, 
        driver_name: Booking.driver_name,
        driver_surname: Booking.driver_surname,
        driver_phone: Booking.driver_phone,
        driver_car: Booking.driver_car,
        updated_at: new Date().toLocaleString(),
        message: Booking.message || '',
        description: Booking.description || '',
        marine_subtype_id: Booking.marine_subtype_id,
        icoterm_id: Booking.icoterm_id,
        land_subtype_id: Booking.land_subtype_id,
        railway_subtype_id: Booking.railway_subtype_id,
        marine_line_id: Booking.marine_line_id,
        period_start_at: Booking.period_start_at || '',
        period_end_at: Booking.period_end_at || '',
        issued_price: Booking.issued_price || 0,
        custom_id: Booking.custom_id || 0,
        client: Booking.client || {
            firstname: '',
            lastname: '',
            email: '',
            mobile: ''
        }
    }
}

const BookingEditModal = ({ BookingService, BookingDetailsService, defaultBooking }) => {
    const initSaleModel = () => ({
        container_id: 0,
        bl_id: 0,
        service_id: 0,
        marine_line_id: 0,
        bill_of_landing: "",
        amount: 0,
        unit_id: "",
        agent_price: 0,
        agent_invoice: "",
        client_price: 0,
        client_invoice: ""
    });

    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
    ];

    const marineSubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FCL' },
        { value: 2, label: 'LCL' },
        { value: 3, label: 'Oversized' },
    ];
    
    const landSubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FTL' },
        { value: 2, label: 'LTL' },
        { value: 3, label: 'FCL' },
        { value: 4, label: 'Oversized' },
    ];

    const railwaySubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FCL' },
        { value: 2, label: 'LCL' },
        { value: 3, label: 'Wagon' },
        { value: 4, label: 'Cistern' },
        { value: 5, label: 'Oversized' },
    ];

    const incotermTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FOB' },
        { value: 2, label: 'FCA' },
        { value: 3, label: 'ExW' },
        { value: 4, label: 'DAP' },
        { value: 5, label: 'CIF' },
    ];

    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'გაუქმებული' },
        { value: 2, label: 'გზაში' },
        { value: 3, label: 'დასრულებული' },
        { value: 4, label: 'მიმდინარე' },
    ];

    const customsTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'იმპორტი' },
        { value: 2, label: 'ექსპორტი' },
        { value: 3, label: 'ტრანზიტი' },
        { value: 4, label: 'რეექსპორტი' },
    ];

    const { appState } = useContext(AppContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [tmpStatus, setTmpStatus] = useState(0);
    const [newBooking, setNewBooking] = useState(initEditPrice(defaultBooking));
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    const [validates, setValidates] = useState({});
    const [textValue, setTextValue] = useState(newBooking.message || '');
    const [descriptionValue, setDescriptionValue] = useState(newBooking.description || '');
    const [salesData, setSalesData] = useState([]);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

    const [typeId, setTypeId] = useState(defaultBooking.type_id)
    const [invoiceDetails, SetInvoiceDetails] = useState({})

    useEffect(() => {
        if (defaultBooking) {
            setNewBooking(initEditPrice(defaultBooking));
            setTextValue(defaultBooking.message || '');
            loadSalesData(defaultBooking.id);
        }
    }, [defaultBooking]);
  
    const loadSalesData = async (bookingId) => {
        try {
            const details = await BookingDetailsService.getByBookingId(bookingId);
            if(details != null) {
                setSalesData(details.booking_details.map((detail, index) => ({
                    id: index + 1,
                    data: detail,
                    isLoaded:true
                })));
            }
        } catch (error) {
            console.error("Error loading sales data:", error);
        }
    };

    const updateSaleData = (id, newData) => {
        setSalesData(prev =>
        prev.map(sale =>
            sale.id === id
            ? { ...sale, isLoaded: sale.isLoaded ?? false, data: { ...sale.data, ...newData } }
            : sale
        )
        );
    };
  
    const addSale = () => {    
        setSalesData(prev => {
            const newId = prev.length > 0 ? Math.max(...prev.map(s => s.id)) + 1 : 1;
            return [...prev, { id: newId, data: initSaleModel(), isLoaded: true }];
        });
    };
  
    const removeSale = (id) => {
        setSalesData(salesData.filter((sale) => sale.id !== id));
    };

    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setTextValue(newValue);
        setNewBooking(prev => ({
            ...prev,
            message: newValue
        }));
    };

    const handleDescriptionChange = (e) => {
        const newValue = e.target.value;
        setDescriptionValue(newValue);
        setNewBooking(prevPrice => ({
            ...prevPrice,
            description: newValue
        }));
    };

    const handleTypeIdChange = (selectedOption) => {
        setTypeId(selectedOption.value)
        setNewBooking(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            icoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleLandSubtypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleRailwaySubtypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleStatusTypeChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            status_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const openAdd = () => {
        setNewBooking(initEditPrice(defaultBooking))
        setIsModalOpen(true)
    }

    const openStatusChangeConfirmation = (selectedOption) => {
        setTmpStatus(selectedOption.value)
        setIsConfirmationOpen(true)
    }

    const closeStatusChangeConfirmation = () => {
        setIsConfirmationOpen(false)
    }

    const confirmStatusChange = () => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            status_id: tmpStatus
        }));
        setTmpStatus(0)
        setIsConfirmationOpen(false)
    }

    const updateClientInvoiceDetails = (newValue) => {
        SetInvoiceDetails(newValue)
    }

    const validateBooking = (Booking) => {
        const messages = {};
        // Sender validation
        if (Booking.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Receiver validation
        if (Booking.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Customs type validation
        if (!Booking.custom_id || Booking.custom_id < 1) {
            messages.custom_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Status validation
        if (!Booking.status_id || Booking.status_id < 1) {
            messages.status_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Transport type validation
        if (!Booking.type_id || Booking.type_id < 1) {
            messages.type_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Subtype validation based on transport type
        if (Booking.type_id === 1 && Booking.marine_subtype_id < 1) {
            messages.marine_subtype_id = { message: 'სავალდებულოა', isValid: false };
        } else if (Booking.type_id === 2 && Booking.land_subtype_id < 1) {
            messages.land_subtype_id = { message: 'სავალდებულოა', isValid: false };
        } else if (Booking.type_id === 3 && Booking.railway_subtype_id < 1) {
            messages.railway_subtype_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Incoterm validation
        if (!Booking.icoterm_id || Booking.icoterm_id < 1) {
            messages.icoterm_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Marine line validation
        if (!Booking.marine_line_id || Booking.marine_line_id < 1) {
            messages.marine_line_id = { message: 'სავალდებულოა', isValid: false };
        }

        // Driver fields validation for land transport
        if (Booking.type_id === 2) {
            if (!Booking.driver_id || Booking.driver_id.length < 1) {
                messages.driver_id = { message: 'სავალდებულოა', isValid: false };
            }
            if (!Booking.driver_name || Booking.driver_name.length < 2) {
                messages.driver_name = { message: 'სავალდებულოა', isValid: false };
            }
            if (!Booking.driver_surname || Booking.driver_surname.length < 2) {
                messages.driver_surname = { message: 'სავალდებულოა', isValid: false };
            }
            if (!Booking.driver_phone || !validatePhoneNumber(Booking.driver_phone)) {
                messages.driver_phone = { message: 'არასწორი ნომერი', isValid: false };
            }
            if (!Booking.driver_car || Booking.driver_car.length < 2) {
                messages.driver_car = { message: 'სავალდებულოა', isValid: false };
            }
        }

        // Sales validation
        if (!salesData || salesData.length === 0) {
            messages.sales = { message: 'მინიმუმ ერთი სეილი სავალდებულოა', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;
    };

    const saveHandle = async () => {
        const isValidate = validateBooking(newBooking);

        if (isValidate) {
            try {
                // Update booking
                const updatedBooking = {
                    ...newBooking,
                    updated_at: new Date().toLocaleString()
                };
                
                // First update the booking
                await BookingService.update(updatedBooking);
                
                // Then update all sales
                const updatePromises = salesData.map(sale => {
                    return BookingDetailsService.update({
                        ...sale.data,
                        booking_id: newBooking.id
                    });
                });
                
                await Promise.all(updatePromises);
                
                setIsModalOpen(false);
            } catch (error) {
                console.error("Error saving booking:", error);
            }
        }
    };

    const selectStyle = {
        control: (provided) => ({
            ...provided,
            minHeight: '35px',
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
            position: 'relative',
            zIndex: 2
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            position: 'relative'
        }),
        menuPortal: base => ({
            ...base,
            zIndex: 9999
        })
    };

    const getErrorStyle = (fieldName) => {
        const hasError = validates && validates[fieldName];

        return {
            ...selectStyle,
            control: (provided, state) => ({
                ...provided,
                border: hasError ? '1px solid rgb(225, 29, 72)' : provided.border,
                '&:hover': {
                    border: hasError ? '1px solid rgb(225, 29, 72)' : provided.border,
                },
                minHeight: '35px',
                width: '100%',
                cursor: 'pointer',
                borderRadius: '5px',
                zIndex: 2
            }),
            menu: (provided) => ({
                ...provided,
                zIndex: 9999
            }),
            menuPortal: (base) => ({
                ...base,
                zIndex: 9999
            })
        };
    };

    const getInputErrorClass = (fieldName) => {
        return validates && validates[fieldName] ? cl.error : '';
    };

    const getTextareaErrorStyle = (fieldName) => {
        return validates && validates[fieldName] ? {
            border: '1px solid rgb(225 29 72)',
            borderRadius: '6px',
            padding: '8px'
        } : {
            border: '1px solid grey',
            borderRadius: '6px',
            padding: '8px'
        };
    };

    const handleCustomsChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            custom_id: selectedOption ? selectedOption.value : 0
        }));
    };

    return(
        <div>
            <span className={cl.editBtn} onClick={() => openAdd()} >
                <Pen /> განახლება
            </span>

            <Modal size="xl" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead}>
                    <h3><span className={cl.iconHead}><Pen /></span> განახლება</h3>
                </div>

                <fieldset className={cl.formField} style={{marginTop: '15px'}}>
                    <legend>ჩატვირთვის ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.sender_country_id}
                        childId={newBooking.sender_city_id}
                        isNetwork={true}
                        styles={getErrorStyle('sender_country_id')}
                        onChange={async (sender_country_id, sender_city_id) => {
                            setNewBooking(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub={typeId == 2 ? "ქვეყანა" : "პორტი"}
                        validate={validates && validates.sender_country_id ? true : false}
                        validateSub={validates && validates.sender_city_id ? true : false}
                        menuPortalTarget={document.body}
                    />
                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.reciever_country_id}
                        childId={newBooking.reciever_city_id}
                        isNetwork={true}
                        styles={getErrorStyle('reciever_country_id')}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewBooking(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub={typeId == 2 ? "ქვეყანა" : "პორტი"}
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                        menuPortalTarget={document.body}
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საბაჟოს ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={getErrorStyle('custom_id')}
                            options={customsTypeOptions}
                            value={customsTypeOptions.find(option => option.value === newBooking.custom_id)}
                            onChange={handleCustomsChange}
                            placeholder="ტიპი"
                            menuPortalTarget={document.body}
                        />
                        {validates?.custom_id && <span className={cl.errorMessage}>{validates.custom_id.message}</span>}
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={getErrorStyle('status_id')}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newBooking.status_id)}
                            onChange={openStatusChangeConfirmation}
                            placeholder="ტიპი"
                            menuPortalTarget={document.body}
                        />
                        {validates?.status_id && <span className={cl.errorMessage}>{validates.status_id.message}</span>}
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={getErrorStyle('type_id')}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newBooking.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                            menuPortalTarget={document.body}
                        />
                        {validates?.type_id && <span className={cl.errorMessage}>{validates.type_id.message}</span>}
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {typeId == 2 && (
                    <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_id')}`}
                                    value={newBooking.driver_id || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_id: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის პ/ნ"
                                />
                                {validates?.driver_id && <span className={cl.errorMessage}>{validates.driver_id.message}</span>}
                            </div>
                            
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_name')}`}
                                    value={newBooking.driver_name || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_name: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის სახელი"
                                />
                                {validates?.driver_name && <span className={cl.errorMessage}>{validates.driver_name.message}</span>}
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_surname')}`}
                                    value={newBooking.driver_surname || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_surname: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის გვარი"
                                />
                                {validates?.driver_surname && <span className={cl.errorMessage}>{validates.driver_surname.message}</span>}
                            </div>
                            
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${getInputErrorClass('driver_phone')}`}
                                    value={newBooking.driver_phone || ''}
                                    onChange={(e) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            driver_phone: e.target.value
                                        }));
                                    }}
                                    placeholder="მძღოლის ტელეფონი"
                                />
                                {validates?.driver_phone && <span className={cl.errorMessage}>{validates.driver_phone.message}</span>}
                            </div>
                        </div>
                        <div style={{ width: "80%" }}>
                            <input
                                type="text"
                                className={`${cl.input} ${getInputErrorClass('driver_car')}`}
                                value={newBooking.driver_car || ''}
                                onChange={(e) => {
                                    setNewBooking(prevState => ({
                                        ...prevState,
                                        driver_car: e.target.value
                                    }));
                                }}
                                placeholder="სატრ.საშუალების ნომერი"
                            />
                            {validates?.driver_car && <span className={cl.errorMessage}>{validates.driver_car.message}</span>}
                        </div>
                    </fieldset>
                )}

                {newBooking.type_id === 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={getErrorStyle('marine_subtype_id')}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newBooking.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                                menuPortalTarget={document.body}
                            />
                            {validates?.marine_subtype_id && <span className={cl.errorMessage}>{validates.marine_subtype_id.message}</span>}
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={getErrorStyle('land_subtype_id')}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newBooking.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                                menuPortalTarget={document.body}
                            />
                            {validates?.land_subtype_id && <span className={cl.errorMessage}>{validates.land_subtype_id.message}</span>}
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 3 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={getErrorStyle('railway_subtype_id')}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newBooking.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                                menuPortalTarget={document.body}
                            />
                            {validates?.railway_subtype_id && <span className={cl.errorMessage}>{validates.railway_subtype_id.message}</span>}
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                    </fieldset>
                ) : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={getErrorStyle('icoterm_id')}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                                menuPortalTarget={document.body}
                            />
                            {validates?.icoterm_id && <span className={cl.errorMessage}>{validates.icoterm_id.message}</span>}
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}

                {
                    typeId == 2 ? 
                        <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                            <legend>აგენტი</legend>

                            <div style={{ width: "50%" }}>
                                <Select
                                    styles={getErrorStyle('marine_line_id')}
                                    options={agents}
                                    value={agents.find(option => option.value === newBooking.marine_line_id)}
                                    onChange={(selectedOption) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            marine_line_id: selectedOption ? selectedOption.value : 0,
                                        }));

                                        if (selectedOption) {
                                            setNewBooking(prevState => ({
                                                ...prevState,
                                            }));
                                        } else {
                                            setTypeOptions(initialTypeOptions);
                                        }
                                    }}
                                    placeholder="აგენტი"
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                />
                                {validates?.marine_line_id && <span className={cl.errorMessage}>{validates.marine_line_id.message}</span>}
                            </div>
                        </fieldset> 
                :
                        <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                            <legend>საზღვაო ხაზი</legend>

                            <div style={{ width: "50%" }}>
                                <Select
                                    styles={getErrorStyle('marine_line_id')}
                                    options={marines}
                                    value={marines.find(option => option.value === newBooking.marine_line_id)}
                                    onChange={(selectedOption) => {
                                        setNewBooking(prevState => ({
                                            ...prevState,
                                            marine_line_id: selectedOption ? selectedOption.value : 0,
                                        }));

                                        if (selectedOption) {
                                            setNewBooking(prevState => ({
                                                ...prevState,
                                            }));
                                        } else {
                                            setTypeOptions(initialTypeOptions);
                                        }
                                    }}
                                    placeholder="საზღვაო ხაზი"
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                />
                                {validates?.marine_line_id && <span className={cl.errorMessage}>{validates.marine_line_id.message}</span>}
                            </div>
                        </fieldset>
                }

                <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                    <div style={{ width: "50%" }}>
                        <input
                            type="number"
                            className={`${cl.input} ${getInputErrorClass('issued_price')}`}
                            value={newBooking.issued_price || 0}
                            onChange={(e) => {
                                setNewBooking(prevState => ({
                                    ...prevState,
                                    issued_price: parseInt(e.target.value)
                                }));
                            }}
                            placeholder="გაცემული ფასი"
                        />
                        {validates?.issued_price && <span className={cl.errorMessage}>{validates.issued_price.message}</span>}
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="message"
                        value={textValue}
                        onChange={handleTextChange}
                        rows={4}
                        cols={100}
                        style={getTextareaErrorStyle('message')}
                        placeholder="კომენტარი"
                    />
                    {validates?.message && <span className={cl.errorMessage}>{validates.message.message}</span>}
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="description"
                        value={descriptionValue}
                        onChange={handleDescriptionChange}
                        rows={4}
                        cols={100}
                        style={getTextareaErrorStyle('description')}
                        placeholder="Description"
                    />
                    {validates?.description && <span className={cl.errorMessage}>{validates.description.message}</span>}
                </fieldset>

                <Invoice booking={newBooking} data={invoiceDetails} clientItem={newBooking.client} />

                <h2 style={{textAlign: 'center'}}>SALE</h2>
                {validates?.sales && <span className={cl.errorMessage} style={{display: 'block', textAlign: 'center'}}>{validates.sales.message}</span>}
                <button onClick={addSale} className={cl.btnPrimary} style={{marginLeft: '0', marginBottom: '20px'}}>
                    სეილის დამატება
                </button>

                <div>
                    {salesData.map((sale) => (
                        <div key={sale.id}>
                            <Sale 
                                key={sale.id}
                                id={sale.id}
                                saleData={sale.data}
                                onUpdate={updateSaleData}
                                isUpdate={!!sale.isLoaded}
                                updateInvoiceDetails={updateClientInvoiceDetails}
                                booking={newBooking}
                            />
                            <button 
                                className={cl.btnPrimary} 
                                style={{backgroundColor:'rgb(255, 68, 68)', marginLeft: '0', marginBottom: '20px'}} 
                                onClick={() => removeSale(sale.id)}
                            >
                                Remove
                            </button>
                        </div>
                    ))}
                </div>

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>
            </Modal>

            <Modal key={defaultBooking.id} size="medium" isOpen={isConfirmationOpen} onClose={() => closeStatusChangeConfirmation()}>

                <div className={ cl.modalHead }><h3>დადასტურება</h3></div> 
                <div className={ cl.message } >გსურთ სტატუსის შეცვლა?</div>
                <div className={ cl.buttons }>
                    <button className={ cl.btnPrimary } onClick={confirmStatusChange}>დიახ მსურს!</button> 
                </div> 
            </Modal>

        </div>
    )
}

export default BookingEditModal;